import { render, staticRenderFns } from "./RecordStoryButton.vue?vue&type=template&id=89b26f9c&scoped=true&"
import script from "./RecordStoryButton.vue?vue&type=script&lang=ts&"
export * from "./RecordStoryButton.vue?vue&type=script&lang=ts&"
import style0 from "./RecordStoryButton.vue?vue&type=style&index=0&id=89b26f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b26f9c",
  null
  
)

export default component.exports